"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIPlanningItemBaseEntity = void 0;
const iplanning_item_data_entity_1 = require("./iplanning-item-data-entity");
function parseIPlanningItemBaseEntity(data) {
    if (typeof data.creation_date === 'string')
        data.creation_date = new Date(data.creation_date);
    if (data.data !== null && typeof data.data === 'object')
        data.data = (0, iplanning_item_data_entity_1.parseIPlanningItemDataEntity)(data.data);
    return data;
}
exports.parseIPlanningItemBaseEntity = parseIPlanningItemBaseEntity;
